/// <reference lib="dom" />
/**
 * @internal
 */
export var Native;
(function (Native) {
    function fromWindow(myWindow = window) {
        return toDevice();
        function toDevice() {
            const { documentElement: { clientWidth, clientHeight }, } = myWindow.document;
            return {
                type: "screen",
                viewport: {
                    width: clientWidth,
                    height: clientHeight,
                    orientation: myWindow.matchMedia("(orientation: landscape)").matches
                        ? "landscape"
                        : "portrait",
                },
                display: { resolution: myWindow.devicePixelRatio, scan: "progressive" },
                scripting: {
                    enabled: !myWindow.matchMedia("(scripting: none)").matches,
                },
                preferences: [...toPreferences()],
            };
        }
        function* toPreferences() {
            // Since everything has to be inlined, we need to redeclare it here.
            // Typing ensure that there isn't too many mistakes (a value may
            // still be missing).
            const preferences = {
                "forced-colors": ["none", "active"],
                inverted: ["none", "inverted"],
                "prefers-color-scheme": ["no-preference", "light", "dark"],
                "prefers-contrast": ["no-preference", "less", "more", "custom"],
                "prefers-reduced-motion": ["no-preference", "reduce"],
                "prefers-reduced-transparency": ["no-preference", "reduce"],
                "prefers-reduced-data": ["no-preference", "reduce"],
            };
            // It seems we need to manually query each preference individually.
            for (const name of Object.keys(preferences)) {
                for (const value of preferences[name]) {
                    if (myWindow.matchMedia(`(${name}: ${value})`).matches) {
                        yield { name, value };
                    }
                }
            }
        }
    }
    Native.fromWindow = fromWindow;
})(Native || (Native = {}));
//# sourceMappingURL=native.js.map